'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { PARENT_CONTACT_URL } from '@/lib/siteUrls';
import { LocaleToggle } from './LocaleToggle';
import { ViewToggle } from './ViewToggle';
import { WantekMark } from './WantekMark';

export function Header() {
  const t = useTranslations('Header');

  return (
    <header className="fixed top-0 inset-x-0 z-50 flex items-center justify-between px-6 py-4">
      <Link
        href="/"
        className="flex items-center gap-3 text-(--color-muted) hover:text-(--color-accent) transition-colors"
        aria-label={t('brand')}
      >
        <WantekMark className="h-5 w-auto text-(--color-accent)" />
        <span className="font-mono text-[0.65rem] uppercase tracking-[6px] hidden sm:inline">
          {t('brand')}
        </span>
      </Link>
      <nav className="flex items-center gap-6">
        <ViewToggle />
        <LocaleToggle />
        <a
          href={PARENT_CONTACT_URL}
          aria-label={t('contactAriaLabel')}
          className="text-xs uppercase tracking-widest text-(--color-muted-foreground) hover:text-(--color-accent)"
        >
          {t('contact')}
        </a>
      </nav>
    </header>
  );
}
